<template>
	<svg id="Group_45734" data-name="Group 45734" xmlns="http://www.w3.org/2000/svg" width="231" height="151" viewBox="0 0 231 151">
		<g id="Group_45739" data-name="Group 45739">
			<path
				id="Path_32905"
				data-name="Path 32905"
				d="M220.044,150.562H11.055A10.581,10.581,0,0,1,.473,139.981V13.4H230.527v126.68a10.483,10.483,0,0,1-10.483,10.483"
				fill="#f7f8fb"
			/>
			<path
				id="Path_32906"
				data-name="Path 32906"
				d="M220.24.5H10.761C5.085.5.473,5.476.473,11.576v1.8H230.527v-1.8C230.527,5.476,225.916.5,220.24.5"
				fill="#f7f7f7"
			/>
			<path
				id="Path_32907"
				data-name="Path 32907"
				d="M220.24.5H10.761C5.085.5.473,5.476.473,11.576v1.8H230.527v-1.8C230.527,5.476,225.916.5,220.24.5"
				fill="#f7f7f7"
			/>
			<path id="Path_32908" data-name="Path 32908" d="M12,7.54A2.145,2.145,0,1,1,9.86,5.39,2.151,2.151,0,0,1,12,7.54" fill="#f7f8fb" />
			<path id="Path_32909" data-name="Path 32909" d="M18.33,7.54a2.15,2.15,0,1,1-2.15-2.15,2.153,2.153,0,0,1,2.15,2.15" fill="#f7f8fb" />
			<path id="Path_32910" data-name="Path 32910" d="M24.66,7.54a2.15,2.15,0,1,1-2.15-2.15,2.16,2.16,0,0,1,2.15,2.15" fill="#f7f8fb" />
			<path
				id="Path_32911"
				data-name="Path 32911"
				d="M185.14,7.56a3.312,3.312,0,0,1-3.3,3.3H48.39a3.3,3.3,0,0,1-3.3-3.3,3.312,3.312,0,0,1,3.3-3.3H181.84a3.3,3.3,0,0,1,3.3,3.3"
				fill="#f7f8fb"
			/>
			<path
				id="Path_32912"
				data-name="Path 32912"
				d="M185.14,7.56a3.312,3.312,0,0,1-3.3,3.3H48.39a3.3,3.3,0,0,1-3.3-3.3,3.312,3.312,0,0,1,3.3-3.3H181.84a3.3,3.3,0,0,1,3.3,3.3"
				fill="#d6dde9"
			/>
			<path id="Path_32913" data-name="Path 32913" d="M12,7.54A2.145,2.145,0,1,1,9.86,5.39,2.151,2.151,0,0,1,12,7.54" fill="#d6dde9" />
			<path id="Path_32914" data-name="Path 32914" d="M18.33,7.54a2.15,2.15,0,1,1-2.15-2.15,2.153,2.153,0,0,1,2.15,2.15" fill="#d6dde9" />
			<path id="Path_32915" data-name="Path 32915" d="M24.66,7.54a2.15,2.15,0,1,1-2.15-2.15,2.16,2.16,0,0,1,2.15,2.15" fill="#d6dde9" />
			<path
				id="Path_32916"
				data-name="Path 32916"
				d="M219.76,0H11.24A11.256,11.256,0,0,0,0,11.24V139.76A11.25,11.25,0,0,0,11.24,151H219.76A11.25,11.25,0,0,0,231,139.76V11.24A11.256,11.256,0,0,0,219.76,0M11.24,1H219.76A10.253,10.253,0,0,1,230,11.24V12.9H1V11.24A10.253,10.253,0,0,1,11.24,1M219.76,150H11.24A10.247,10.247,0,0,1,1,139.76V13.9H230V139.76A10.247,10.247,0,0,1,219.76,150"
				fill="#e5e9ef"
			/>
			<path
				id="Path_32917"
				data-name="Path 32917"
				d="M154.751,24.411h-78.5a9.275,9.275,0,0,0-9.275,9.275v97.532a9.274,9.274,0,0,0,9.275,9.275h78.5a9.274,9.274,0,0,0,9.275-9.275V33.686a9.275,9.275,0,0,0-9.275-9.275"
				fill="#fff"
			/>
			<path
				id="Path_32918"
				data-name="Path 32918"
				d="M154.751,140.993h-78.5a9.785,9.785,0,0,1-9.775-9.775V33.686a9.785,9.785,0,0,1,9.775-9.775h78.5a9.785,9.785,0,0,1,9.775,9.775v97.532a9.785,9.785,0,0,1-9.775,9.775M76.249,24.911a8.785,8.785,0,0,0-8.775,8.775v97.532a8.784,8.784,0,0,0,8.775,8.775h78.5a8.784,8.784,0,0,0,8.775-8.775V33.686a8.785,8.785,0,0,0-8.775-8.775Z"
				fill="#e4e8f2"
			/>
			<path
				id="Path_32919"
				data-name="Path 32919"
				d="M126.038,81.283h-6.164l5.338-3.081-1.173-2.029-5.335,3.08,3.08-5.338-2.029-1.173-3.081,5.337V71.916h-2.348V78.08l-3.08-5.338-2.029,1.173L112.3,79.25l-5.335-3.08L105.788,78.2l5.338,3.081h-6.164v2.344h6.162l-5.336,3.082,1.173,2.028,5.336-3.081-3.081,5.337,2.029,1.173,3.08-5.338v6.163h2.344V86.829l3.081,5.337,2.029-1.172L118.7,85.656l5.336,3.081,1.173-2.029-5.336-3.08h6.162ZM115.5,85.643a3.2,3.2,0,1,1,3.2-3.2,3.2,3.2,0,0,1-3.2,3.2Z"
				fill="#5251f8"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'LoomSvg',
};
</script>

<style scoped lang="scss"></style>
